import React, { Component } from 'react';
import {
    BrowserRouter as Router,
    Route,
    Switch,
    Redirect
} from 'react-router-dom';



import { GoogleMapScript } from './components/googleMapScript';
import LoginPage from './views/loginPage';
import PagesListPage from './views/pagesListPage';
import AddPagePage from './views/addPagePage';
import ContactListPage from './views/contactListPage';
import ContactPreviewPage from './views/contactPreviewPage';
import HomePage from './views/homePage';
import ResultsPreviewPage from './views/resultsPreviewPage';
import AboutUsPage from './views/aboutUsPage';
import PeopleOfFMPage from './views/peopleOfFMPage';
import GalleryPage from './views/galleryPage';
import NewAlbumPage from './views/newAlbumPage';
import UserListPage from './views/userListPage';
import UserPreviewPage from './views/userPreviewPage';
import VideoPage from './views/videoPage';
import GamesResultsPage from './views/gamesResults';

class Routes extends Component {

    componentDidMount() {

    }

    render() {
        return (
            <Router >
                <div>

                    <Switch className="react-switch">
                        <Route
                            path="/"
                            exact
                            render={(...renderProps) => (
                                <HomePage {...renderProps} {...this.props} />
                            )}
                        />



                        <Route
                            path="/stream"
                            exact
                            render={(...renderProps) => (
                                <AboutUsPage {...renderProps} {...this.props} />
                            )}
                        />
                        <Route
                            path="/people-of-fm"
                            exact
                            render={(...renderProps) => (
                                <PeopleOfFMPage {...renderProps} {...this.props} />
                            )}
                        />
                        <Route
                            path="/video"
                            exact
                            render={(...renderProps) => (
                                <VideoPage {...renderProps} {...this.props} />
                            )}
                        />


                        <Route
                            path="/users"
                            exact
                            render={(...renderProps) => (
                                <UserListPage {...renderProps} {...this.props} />
                            )}
                        />
                        <Route
                            path="/users/:id"
                            exact
                            render={(...renderProps) => (
                                <UserPreviewPage {...renderProps} {...this.props} />
                            )}
                        />



                        <Route
                            path="/login"
                            exact
                            render={(...renderProps) => (
                                <LoginPage {...renderProps} {...this.props} />
                            )}
                        />
                        <Route
                            path="/collection/:collection"
                            exact
                            render={(...renderProps) => (
                                <PagesListPage {...renderProps} {...this.props} />
                            )}
                        />
                        <Route
                            path="/collection/:collection/:id"
                            exact
                            render={(...renderProps) => (
                                <AddPagePage {...renderProps} {...this.props} />
                            )}
                        />

                        <Route
                            path="/contacts"
                            exact
                            render={(...renderProps) => (
                                <ContactListPage {...renderProps} {...this.props} />
                            )}
                        />
                        <Route
                            path="/contacts/:id"
                            exact
                            render={(...renderProps) => (
                                <ContactPreviewPage {...renderProps} {...this.props} />
                            )}
                        />
                        <Route
                            path="/gallery"
                            exact
                            render={(...renderProps) => (
                                <GalleryPage {...renderProps} {...this.props} />
                            )}
                        />
                        <Route
                            path="/gallery/:id"
                            exact
                            render={(...renderProps) => (
                                <NewAlbumPage {...renderProps} {...this.props} />
                            )}
                        />
                        <Route
                            path="/games/results"
                            exact
                            render={(...renderProps) => (
                                <GamesResultsPage {...renderProps} {...this.props} />
                            )}
                        />

                        <Route
                            path="/games/results/settings"
                            exact
                            render={(...renderProps) => (
                                <ResultsPreviewPage {...renderProps} {...this.props} />
                            )}
                        />

                        <Route
                            path="/games/results/game/:alias"
                            exact
                            render={(...renderProps) => (
                                <GamesResultsPage {...renderProps} {...this.props} />
                            )}
                        />




                    </Switch>
                </div>
            </Router >
        );
    }
}

export default Routes;